import { useCheckIsIdle } from '@/context/services/hooks/useCheckIsIdle';
import { getPageData } from '@/utils/getPageData';
import { useGetExcisesSuspenseInfinite } from 'ap-openapi';
import { useEffect, useMemo } from 'react';

export const useGetExcisesAllSuspense = () => {
  const checkIsIdle = useCheckIsIdle();

  const { data, error, fetchNextPage, hasNextPage, queryKey } =
    useGetExcisesSuspenseInfinite(
      {
        per: '1000',
      },
      {
        query: {
          getNextPageParam: (page) => {
            const url = new URL(page.data.next ?? '/', location.href);
            if (!url.searchParams.has('page')) return undefined;
            return url.searchParams.get('page');
          },
          staleTime: Infinity,
        },
      }
    );
  if (error) throw error;
  useEffect(() => {
    if (hasNextPage && checkIsIdle(queryKey)) {
      fetchNextPage();
    }
  }, [fetchNextPage, hasNextPage, checkIsIdle, queryKey]);
  return useMemo(() => getPageData(data, 'excises'), [data]);
};
